// @flow
import { css } from 'styled-components';
import mainTheme from '~/core/themes/main';
import { media } from '~/core/utils/style';

const baseCSS = css`
    /*
Use 'border-box' properly:
https://css-tricks.com/inheriting-box-sizing-probably-slightly-better-best-practice/
*/
    html {
        box-sizing: border-box;
        color: ${mainTheme.primaryFontColor};
        font-size: ${mainTheme.mobileFontSize};
    }

    body {
        background-color: ${mainTheme.white};
    }

    body,
    html {
        height: 100%;
        overflow-x: hidden;
        position: relative;
    }

    #app {
        height: 100%;
        overflow-x: hidden;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
    }

    *,
    *:before,
    *:after {
        box-sizing: inherit;
    }

    a {
        color: ${mainTheme.primaryFontColor};
        text-decoration: none;
    }

    ul {
        list-style: none;
        padding: 0;
    }

    /* This css is to counter the normalize css that sets the font-family of these elements to sas-serif */
    button,
    input,
    optgroup,
    select,
    textarea {
        font-family: inherit;
    }

    ${media.tablet`
    html {
        font-size: ${mainTheme.tabletFontSize};
    }
`} ${media.desktop`
    html {
        font-size: ${mainTheme.desktopFontSize};
    }
`};
`;

export default baseCSS;



// WEBPACK FOOTER //
// ./src/components/reset-css/base-css.js